// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"wn_a bib_b bib_we"};